<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<div class="title-acknowPage"><a href="#/e9781429910415_toc01#toctitle1" id="title1"><span><strong class="b">ACKNOWLEDGEMENTS</strong></span></a></div>
<div class="p"><span>As ever, my thanks to Caroline for her support and for being there, to my parents as first readers and critics, and to Peter Lavery for that scary pencil and all those fish-and-chip suppers. Also thanks to all the usual suspects at Macmillan, including in no particular order: Stefanie Bierwerth, Dusty Miller, James Hollywell and Steve Rawlings, Jason Cooper, Chantal Noel, Vivienne Nelson, Rebecca Saunders, Liz Cowen, and many others. And further thanks to John Jarrold for casting a judicious eye over the typescript.</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429910415_ack01.vue?09deb55f